import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useEffect, useState } from 'react';
import { ActiveSubscriptionResponseDto } from '../../../commonTypes/organization.types';

const useHttpGetActiveSubscriptionOnMount = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [activeSubscription, setActiveSubscription] = useState<ActiveSubscriptionResponseDto | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        const { exec, abort } = organizationApi.getActiveSubscription({
            onSuccess: res => {
                setActiveSubscription(res.body);
                setIsLoading(false);
            },
            onError: error => {
                setError(error as Error);
                setIsLoading(false);
            },
        });
        exec();
        return abort;
    }, []);

    return { activeSubscription, isLoading, error };
};

export default useHttpGetActiveSubscriptionOnMount;
